import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Hash, X } from 'lucide-react';

interface RegistroFilterProps {
  registroFilter: string;
  onRegistroFilterChange: (filter: string) => void;
  onClearFilter: () => void;
}

const RegistroFilter: React.FC<RegistroFilterProps> = ({
  registroFilter,
  onRegistroFilterChange,
  onClearFilter,
}) => {
  return (
    <div className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg border">
      <div className="flex items-center gap-2">
        <Hash className="h-4 w-4" />
        <span className="text-sm font-medium">Filtro por n° Registro</span>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600"># Registro</label>
          <Select value={registroFilter || 'todos'} onValueChange={onRegistroFilterChange}>
            <SelectTrigger className="w-full sm:w-48">
              <SelectValue placeholder="Seleccionar registro" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos</SelectItem>
              <SelectItem value="155">155</SelectItem>
              <SelectItem value="207">207</SelectItem>
              <SelectItem value="486">486</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600 invisible">Acciones</label>
          <div className="flex gap-2">
            <Button
              onClick={onClearFilter}
              variant="outline"
              size="sm"
              className="px-3"
              disabled={!registroFilter || registroFilter === 'todos'}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistroFilter;